import { kebabCase } from 'lodash';
import { Dashboard } from './builder.models';
import {
    mdIconLabel,
    multiClasses,
    IqCssClassnames,
} from '@dat/iq-style-processor';
import { createActionListNoRules } from '@dat/iq-workflow';

export const idCreator = (idRoot: string, parts: string[]) => {
    return kebabCase(`${idRoot}-${parts.join('-')}`);
};

type Items = {
    id: string;
    type: string;
    label: string;
    classNames: IqCssClassnames;
    onClick: any[];
};

export const sbDashboardRender = (
    dashboard: Dashboard,
    id: string,
    unavClasses: IqCssClassnames,
    currentRoute: string,
) => {
    return {
        template: `
         <iq-unav-bar [items]="items" [classNames]="unavClassNames">
         <iq-builder-dashboard [dashboard]="dashboard" [id]="id"></iq-builder-dashboard>
     </iq-unav-bar>
            `,
        props: {
            id: id,
            dashboard: dashboard,
            unavClassNames: unavClasses,
            items: [
                {
                    id: 'landing-dashboard',
                    type: 'button',
                    label: mdIconLabel('home', 'Dashboard'),
                    onClick: [
                        ...createActionListNoRules([
                            {
                                name: 'navigateToStory', // Keep this here for now to make it easier to set it for Chromatic
                                payload: {
                                    story: 'landing-dashboard',
                                    title: 'Builder/Stories/Scenarios/Landing/Dashboards',
                                },
                            },
                        ]),
                    ],
                },
                {
                    id: 'rateview',
                    type: 'button',
                    label: mdIconLabel('query_stats', 'Rateview'),
                    onClick: [
                        ...createActionListNoRules([
                            {
                                name: 'navigateToStory', // Keep this here for now to make it easier to set it for Chromatic
                                payload: {
                                    story: 'rv-single-lane-search-results-dashboard',
                                    title: 'Builder/Stories/Scenarios/Rateview/Dashboards',
                                },
                            },
                        ]),
                    ],
                },
                {
                    id: 'trendlines',
                    type: 'button',
                    label: mdIconLabel('leaderboard', 'Trendlines'),
                    onClick: [
                        ...createActionListNoRules([
                            {
                                name: 'navigateToStory', // Keep this here for now to make it easier to set it for Chromatic
                                payload: {
                                    story: 'view-trends-dashboard',
                                    title: 'Builder/Stories/Scenarios/Trendlines/Dashboards',
                                },
                            },
                        ]),
                    ],
                },
                {
                    id: 'mc',
                    type: 'button',
                    label: mdIconLabel('speed', 'MC'),
                    onClick: [
                        ...createActionListNoRules([
                            {
                                name: 'navigateToStory', // Keep this here for now to make it easier to set it for Chromatic
                                payload: {
                                    story: 'mc-dashboard-single',
                                    title: 'Builder/Stories/Scenarios/MC/Dashboards',
                                },
                            },
                        ]),
                    ],
                },
            ].map(
                (item: Items): Items => ({
                    ...item,
                    classNames: {
                        ...(item.classNames ?? {}),
                        ...(item.id === currentRoute
                            ? multiClasses(
                                  ['!text-dat-grey-100'],
                                  ['[data-uitype="button"]'],
                              )
                            : {}),
                    },
                }),
            ),
        },
    };
};
